/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EntityCreationRecurrenceBasic } from '../model';
// @ts-ignore
import { EntityCreationRecurrenceDetail } from '../model';
/**
 * RecurrencesApi - axios parameter creator
 * @export
 */
export const RecurrencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new recurrences
         * @summary Creates a new recurrences
         * @param {EntityCreationRecurrenceDetail} entityCreationRecurrenceDetail Recurrence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurrences: async (entityCreationRecurrenceDetail: EntityCreationRecurrenceDetail, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityCreationRecurrenceDetail' is not null or undefined
            assertParamExists('createRecurrences', 'entityCreationRecurrenceDetail', entityCreationRecurrenceDetail)
            const localVarPath = `/admin/recurrences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityCreationRecurrenceDetail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an existing recurrence.
         * @summary Deletes an existing recurrence
         * @param {number} id recurrence ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecurrence: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRecurrence', 'id', id)
            const localVarPath = `/admin/recurrences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves the recurrence detail.
         * @param {number} id recurrence ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurrence: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRecurrence', 'id', id)
            const localVarPath = `/admin/recurrences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves all the recurrences.
         * @param {number} entityType Entity Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurrences: async (entityType: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getRecurrences', 'entityType', entityType)
            const localVarPath = `/admin/recurrences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a recurrence
         * @summary Updates a recurrence
         * @param {EntityCreationRecurrenceDetail} entityCreationRecurrenceDetail Recurrence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecurrences: async (entityCreationRecurrenceDetail: EntityCreationRecurrenceDetail, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityCreationRecurrenceDetail' is not null or undefined
            assertParamExists('updateRecurrences', 'entityCreationRecurrenceDetail', entityCreationRecurrenceDetail)
            const localVarPath = `/admin/recurrences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityCreationRecurrenceDetail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecurrencesApi - functional programming interface
 * @export
 */
export const RecurrencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecurrencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new recurrences
         * @summary Creates a new recurrences
         * @param {EntityCreationRecurrenceDetail} entityCreationRecurrenceDetail Recurrence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRecurrences(entityCreationRecurrenceDetail: EntityCreationRecurrenceDetail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityCreationRecurrenceDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRecurrences(entityCreationRecurrenceDetail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes an existing recurrence.
         * @summary Deletes an existing recurrence
         * @param {number} id recurrence ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRecurrence(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRecurrence(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary retrieves the recurrence detail.
         * @param {number} id recurrence ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecurrence(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityCreationRecurrenceDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecurrence(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary retrieves all the recurrences.
         * @param {number} entityType Entity Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecurrences(entityType: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityCreationRecurrenceBasic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecurrences(entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates a recurrence
         * @summary Updates a recurrence
         * @param {EntityCreationRecurrenceDetail} entityCreationRecurrenceDetail Recurrence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRecurrences(entityCreationRecurrenceDetail: EntityCreationRecurrenceDetail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityCreationRecurrenceDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRecurrences(entityCreationRecurrenceDetail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RecurrencesApi - factory interface
 * @export
 */
export const RecurrencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecurrencesApiFp(configuration)
    return {
        /**
         * Creates a new recurrences
         * @summary Creates a new recurrences
         * @param {EntityCreationRecurrenceDetail} entityCreationRecurrenceDetail Recurrence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurrences(entityCreationRecurrenceDetail: EntityCreationRecurrenceDetail, options?: any): AxiosPromise<EntityCreationRecurrenceDetail> {
            return localVarFp.createRecurrences(entityCreationRecurrenceDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an existing recurrence.
         * @summary Deletes an existing recurrence
         * @param {number} id recurrence ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecurrence(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRecurrence(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary retrieves the recurrence detail.
         * @param {number} id recurrence ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurrence(id: number, options?: any): AxiosPromise<EntityCreationRecurrenceDetail> {
            return localVarFp.getRecurrence(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary retrieves all the recurrences.
         * @param {number} entityType Entity Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurrences(entityType: number, options?: any): AxiosPromise<Array<EntityCreationRecurrenceBasic>> {
            return localVarFp.getRecurrences(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a recurrence
         * @summary Updates a recurrence
         * @param {EntityCreationRecurrenceDetail} entityCreationRecurrenceDetail Recurrence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecurrences(entityCreationRecurrenceDetail: EntityCreationRecurrenceDetail, options?: any): AxiosPromise<EntityCreationRecurrenceDetail> {
            return localVarFp.updateRecurrences(entityCreationRecurrenceDetail, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecurrencesApi - object-oriented interface
 * @export
 * @class RecurrencesApi
 * @extends {BaseAPI}
 */
export class RecurrencesApi extends BaseAPI {
    /**
     * Creates a new recurrences
     * @summary Creates a new recurrences
     * @param {EntityCreationRecurrenceDetail} entityCreationRecurrenceDetail Recurrence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurrencesApi
     */
    public createRecurrences(entityCreationRecurrenceDetail: EntityCreationRecurrenceDetail, options?: any) {
        return RecurrencesApiFp(this.configuration).createRecurrences(entityCreationRecurrenceDetail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an existing recurrence.
     * @summary Deletes an existing recurrence
     * @param {number} id recurrence ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurrencesApi
     */
    public deleteRecurrence(id: number, options?: any) {
        return RecurrencesApiFp(this.configuration).deleteRecurrence(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary retrieves the recurrence detail.
     * @param {number} id recurrence ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurrencesApi
     */
    public getRecurrence(id: number, options?: any) {
        return RecurrencesApiFp(this.configuration).getRecurrence(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary retrieves all the recurrences.
     * @param {number} entityType Entity Type ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurrencesApi
     */
    public getRecurrences(entityType: number, options?: any) {
        return RecurrencesApiFp(this.configuration).getRecurrences(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a recurrence
     * @summary Updates a recurrence
     * @param {EntityCreationRecurrenceDetail} entityCreationRecurrenceDetail Recurrence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurrencesApi
     */
    public updateRecurrences(entityCreationRecurrenceDetail: EntityCreationRecurrenceDetail, options?: any) {
        return RecurrencesApiFp(this.configuration).updateRecurrences(entityCreationRecurrenceDetail, options).then((request) => request(this.axios, this.basePath));
    }
}
